export default {
  state: () => ({
    cardNumber: "",
    cvv: "",
    expirationDate: "",
    idNumber: "",
  }),
  getters: {
    getCardNumber: (state) => {
      return state.cardNumber;
    },
    getCvv: (state) => {
      return state.cvv;
    },
    getExpirationDate: (state) => {
      return state.expirationDate;
    },
    getIdNumber: (state) => {
      return state.idNumber;
    },
  },
  mutations: {
    setCardNumber(state, data) {
      state.cardNumber = data;
    },
    setCvv(state, data) {
      state.cvv = data;
    },
    setExpirationDate(state, data) {
      state.expirationDate = data;
    },
    setIdNumber(state, data) {
      state.idNumber = data;
    },
  },
  namespaced: true,
};
